import { IconX } from 'featherico';
import * as React from 'react';
import Button from '../../components/Button';
import styles from './style.m.less';

interface Props {
    onDone?(): void;
    children: React.ReactNode;
}

export default function HeaderSpark({ onDone, children }: Props) {
    return (
        <div className={styles.container}>
            <div className={styles.message}>{children}</div>
            {onDone && (
                <Button kind="PLAIN" onClick={onDone} aria-label="Dismiss">
                    <IconX />
                </Button>
            )}
        </div>
    );
}
